{
  "title": "Light",
  "source": "Player's Handbook",
  "levelAndSchool": "Evocation cantrip",
  "level": 0,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, M (a firefly or phosphorescent moss)",
  "duration": "1 hour",
  "description": [
    "You touch one object that is no larger than 10 feet in any dimension. Until the spell ends, the object sheds bright light in a 20-foot radius and dim light for an additional 20 feet. The light can be colored as you like. Completely covering the object with something opaque blocks the light. The spell ends if you cast it again or dismiss it as an action.",
    "If you target an object held or worn by a hostile creature, that creature must succeed on a Dexterity saving throw to avoid the spell."
  ],
  "spellLists": [
    "artificer",
    "bard",
    "cleric",
    "eldritch-knight",
    "arcane-trickster",
    "sorcerer",
    "wizard"
  ]
}
